import {
  getCarrier,
  getFullNameFromOrder,
  getItemId,
  getNameFromItem,
  getTotalPriceOfItems,
  getTotalPriceOfSubscriptionItems,
  getTrackingNumber,
} from './decisionTreeUtil';
// these values corespond with the orderSystemMapping keys for orders, not items

export const orderFields = [
  'orderId',
  'orderNumber',
  'totalPrice',
  'fullName',
  'currency',
  'createdAt',
  'domain',
  'totalPriceOfItems',
  'email',
  'totalTax',
  'riskLevel',
];

// these values corespond with the orderSystemMapping keys for items, not orders

export const itemFields = [
  'itemId',
  'price',
  'points',
  'sku',
  'name',
  'quantity',
  'carrier',
  'trackingNumber',
  'status',
  'trackingNumberAsLink', // no selector - used in info widget
];

export const subscriptionFields = ['totalPriceOfSubscriptionItems'];

/**
 * The below object maps the non-system specific order/item field to the system specific value
 *
 * For values which are functions, we pass in the object as the first arg and the system as the second arg
 */

export const orderSystemMappings = {
  common: {
    itemId: getItemId,
    orderId: 'orderId',
    totalPrice: 'orderTotal', // on ORDER
    fullName: getFullNameFromOrder,
    currency: 'currency',
    createdAt: 'createdAt',
    quantity: 'itemQuantity',
    name: getNameFromItem,
    price: 'paidItemTotalPrice', // on ITEM
    points: '',
    domain: 'domain',
    sku: 'itemSKU',
    orderNumber: 'orderNumber',
    email: 'customerEmail',
    totalTax: 'orderTax',
    status: 'status',
    carrier: getCarrier,
    trackingNumber: getTrackingNumber,
    totalPriceOfItems: getTotalPriceOfItems,
    totalPriceOfSubscriptionItems: getTotalPriceOfSubscriptionItems, // not yet supported
  },
  shopify: {
    itemId: getItemId,
    orderId: 'id',
    totalPrice: 'total_price', // on ORDER
    fullName: getFullNameFromOrder,
    currency: 'currency',
    createdAt: 'created_at',
    quantity: 'quantity',
    name: getNameFromItem,
    price: 'price', // on ITEM
    points: '',
    sku: 'sku',
    orderNumber: 'name',
    email: 'email',
    totalTax: 'total_tax',
    status: '',
    carrier: getCarrier,
    trackingNumber: getTrackingNumber,
    totalPriceOfItems: getTotalPriceOfItems,
    totalPriceOfSubscriptionItems: getTotalPriceOfSubscriptionItems,
    riskLevel: 'riskLevel',
  },
  custom_rbi: {
    itemId: getItemId,
    orderId: 'rbiOrderId',
    totalPrice: 'totalCents', // on ORDER
    fullName: getFullNameFromOrder,
    currency: 'currency.code',
    createdAt: 'createdAt',
    quantity: 'quantity',
    name: getNameFromItem,
    price: 'price', // on ITEM
    points: 'points',
    sku: '',
    orderNumber: 'rbiOrderId',
    email: '',
    totalTax: '',
    status: '',
    carrier: getCarrier,
    trackingNumber: getTrackingNumber,
    totalPriceOfItems: getTotalPriceOfItems,
    totalPriceOfSubscriptionItems: getTotalPriceOfSubscriptionItems,
  },
  salesforce: {
    itemId: getItemId,
    orderId: 'Id',
    totalPrice: 'TotalAmount', // on ORDER
    fullName: getFullNameFromOrder,
    currency: '',
    createdAt: 'CreatedDate',
    quantity: 'Quantity',
    name: getNameFromItem,
    price: 'TotalPrice', // on ITEM
    sku: '',
    orderNumber: 'OrderNumber',
    email: '',
    totalTax: '',
    status: '',
    carrier: getCarrier,
    trackingNumber: getTrackingNumber,
    totalPriceOfItems: getTotalPriceOfItems,
    totalPriceOfSubscriptionItems: getTotalPriceOfSubscriptionItems,
  },
  bigCommerce: {
    itemId: getItemId,
    orderId: 'id',
    totalPrice: 'total_inc_tax', // on ORDER
    fullName: getFullNameFromOrder,
    currency: 'currency_code',
    createdAt: 'date_created',
    quantity: 'items_total',
    name: getNameFromItem,
    price: 'base_price', // on ITEM
    sku: 'sku',
    orderNumber: 'id',
    email: 'billing_address.email',
    totalTax: 'total_tax',
    status: '',
    carrier: getCarrier,
    trackingNumber: getTrackingNumber,
    totalPriceOfItems: getTotalPriceOfItems,
    totalPriceOfSubscriptionItems: getTotalPriceOfSubscriptionItems,
  },
  revolve: {
    itemId: getItemId,
    orderId: 'id',
    totalPrice: 'totalPrice', // on ORDER
    fullName: getFullNameFromOrder,
    currency: '',
    createdAt: 'createdAt',
    quantity: 'quantity',
    name: getNameFromItem,
    price: 'wShip', // on ITEM
    orderNumber: 'id',
    email: '',
    totalTax: '',
    status: '',
    carrier: getCarrier,
    trackingNumber: getTrackingNumber,
    totalPriceOfItems: getTotalPriceOfItems,
    totalPriceOfSubscriptionItems: getTotalPriceOfSubscriptionItems,
  },
};
